var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isComponentContent)?_c(_vm.activeContentComponent,{tag:"component"}):_c('div',{domProps:{"innerHTML":_vm._s(_vm.activeContentResource)}})
}
var staticRenderFns = []

export { render, staticRenderFns }